import { connect } from 'react-redux';
import { compose } from 'redux';
import { withStyles } from '@material-ui/core/styles';
import { withUserGroupMembership } from 'modules/shell/hoc/withUserGroupMembership';
import withFeatureToggles from 'modules/shell/hoc/withFeatureToggles';
import { ENABLE_GIFT_RECEIPT, ENABLE_SPLIT_GIFT_RECEIPT } from 'constants/featureToggleNames';
import OrderDetails from './OrderDetails';
import styles from './OrderDetails.styles';

const mapStateToProps = ({ user }) => {
  const {
    data: { storeNumber },
  } = user;

  return {
    userStoreNumber: storeNumber,
  };
};

export default compose(
  withStyles(styles),
  withUserGroupMembership({
    isUserAGeneralManager: 'store_general_manager',
  }),
  withFeatureToggles({
    isGiftReceiptEnabled: ENABLE_GIFT_RECEIPT,
    isSplitGiftReceiptEnabled: ENABLE_SPLIT_GIFT_RECEIPT,
  }),
  connect(mapStateToProps, null),
)(OrderDetails);
